import { Box, Typography, useTheme } from "@mui/material";
import UserMenu from "../UserMenu";
import { useLocation } from "react-router-dom";
import Navigation, { NavigationTag } from "../Navigation";
import Grid from '@mui/material/Grid2';

const Header = () => {
  const theme = useTheme();
  const location = useLocation();

  const headerTitles: Record<NavigationTag, string> = {
    home: "Home",
    activities: "Activities",
    skills: "Skills",
    artifacts: 'Artifacts'
  };

  const handleNavigate = (
    id: "home" | "activities" | "skills" | "artifacts"
  ) => {
    const target = document.getElementById(id);
    // Instant scrolling is a compromise between intersection observer and link navigation.
    // If set to ‘smooth’, the intersection watcher will be triggered and the url will flicker
    target?.scrollIntoView({ behavior: "auto" });
  };

  return (
    <>
      <Box  sx={{zIndex: 2, backgroundColor: "white"}}>
      <Grid container spacing={2} sx={{height: "62px"}}>
          <Grid size={2} sx={{display: "flex", alignItems: "center", position: "relative" }}>
          <Typography variant="h3" sx={{ pl: "24px", display: "flex", alignContent: "center", fontWeight: 600}}>sff</Typography>
          </Grid>
          <Grid size={8}>
          <Navigation handleNavigate={handleNavigate} />
          </Grid>
          <Grid size={2} display="flex" justifyContent="flex-end" sx={{display: "flex", position: "relative"}}>
          <UserMenu />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Header;
